import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonPrimary, ContainerVertical, ContainerHorizontal, HSpacer, colors, When, LoadingDot, TextArea } from '@aftersale-next/ui';
import * as trackingActions from '../../config/constants/tracking-actions';
import { validateActionDescription } from './utils/validateActionDescription';
export default function NecessaryAction(_ref) {
  var isLoading = _ref.isLoading,
      mutate = _ref.mutate,
      id = _ref.id;

  var _useState = useState(''),
      text = _useState[0],
      setText = _useState[1];

  var _useState2 = useState(false),
      error = _useState2[0],
      setError = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var afterSubmit = function afterSubmit() {
    setText('');
    setError(false);
  };

  var handleSubmit = function handleSubmit() {
    validateActionDescription({
      text: text,
      onValid: function onValid() {
        mutate({
          action: trackingActions.NECESSARY_ACTION,
          informedData: text,
          id: id
        });
        afterSubmit();
      },
      onError: function onError() {
        return setError(true);
      }
    });
  };

  return /*#__PURE__*/_jsx(ContainerHorizontal, {
    children: /*#__PURE__*/_jsxs(ContainerVertical, {
      justify: "center",
      align: "flex-start",
      minHeight: "160px",
      fullWidth: true,
      children: [/*#__PURE__*/_jsx(TextArea, {
        id: "textarea-action",
        name: "textarea-action",
        placeholder: "",
        value: text,
        label: t('COMMENT'),
        error: error,
        onChange: function onChange(value) {
          return setText(value);
        },
        maxLength: 1000
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "15px"
      }), /*#__PURE__*/_jsx(ContainerHorizontal, {
        children: /*#__PURE__*/_jsxs(ButtonPrimary, {
          id: trackingActions.NECESSARY_ACTION,
          disabled: isLoading,
          bgColor: colors.green,
          color: colors.buttonForeground,
          onClick: handleSubmit,
          children: [/*#__PURE__*/_jsx(When, {
            value: !isLoading,
            children: t('SEND')
          }), /*#__PURE__*/_jsx(When, {
            value: isLoading,
            children: /*#__PURE__*/_jsx(LoadingDot, {})
          })]
        })
      })]
    })
  });
}